import * as React from "react";

const SvgPause = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M10.222 9.333v5.334M13.778 9.333v5.334M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
    </g>
  </svg>
);

export default SvgPause;
